import GroupedChart, { type GroupedChartProps } from './GroupedChart';

export type GroupedBarChartProps = Omit<GroupedChartProps, 'mode'>;

const GroupedBarChart = (props: GroupedBarChartProps) => <GroupedChart {...props} mode="bar" />;

export default GroupedBarChart;
